import styled from 'styled-components';

import Link from '~/src/common/components/Link';
import colors from '~/src/common/themes/main/colors';

// Les couleurs sont statiques pour le moment
export const BG_COLOR = colors.WHITE;
export const FG_COLOR = colors.PRIMARY;

export const Container = styled(Link)`
  position: relative;
  display: block;
  padding: 0;
  margin: 0;

  border: 8px solid ${FG_COLOR};
  background: ${BG_COLOR};
  border-radius: 16px;

  svg {
    position: absolute;
    inset: 0;

    display: block;
    width: 100%;
    height: 100%;
    padding: 8px;

    shape-rendering: crispedges;
    transition: opacity 0.2s ease;
    opacity: 0;
  }

  &[aria-busy='false'] svg {
    opacity: 1;
  }
`;
